<!-- labelled groups -->
<div class="spacer-top"></div>
<div class="panel panel-default" ng-hide="vm.fieldgroup.label == ''" tabindex="-1">
  <div class="panel-heading"  tabindex="-1" ng-model="vm.fieldgroup.label">
    <h4>{{vm.fieldgroup.label}}</h4>
  </div>
  <div class="panel-body"  tabindex="-1">
    <div ng-style="{'margin-left': vm.fieldgroup.marginleft}">
      <div ng-repeat="field in vm.fieldgroup.fields">
        <examfield field="field" ti="{{$index}}" gi="{{vm.gi}}" on-field-change="vm.save()"></examfield>
      </div>
    </div>
  </div>
</div>

<!-- unlabelled groups -->
<div class="spacer-top"></div>
<div ng-show="vm.fieldgroup.label == ''"  tabindex="-1">
  <div ng-repeat="field in vm.fieldgroup.fields">
    <examfield field="field" ti="{{$index}}" gi="{{vm.gi}}" on-field-change="vm.save()"></examfield>
  </div>
</div>